helpPageCloseButton = {};

helpPageCloseButton.create = function() {
	var button = new PIXI.Container();

	InputHelpers.addGenerics(button);

	button.canEnable = function() {
		return true;
	};

	button.canShow = function() {
		return true;
	};

	button.onPressedCallback = function() {
		helpPageManager.close();
		if (button.soundName !== "") button.playSound();
	};

	return button;
};

helpPageCloseButton.initialise = function(json, object) {
	object.soundName = json.soundName || "";
};
helpPageCloseButton.getFilesRequired = function() {
	return [];
};

resourceManager.registerObjectType("helpPageCloseButton", helpPageCloseButton.create, helpPageCloseButton.initialise, helpPageCloseButton.getFilesRequired);